import { render } from "./ProfileEditFormPanelV2.vue?vue&type=template&id=5b88daf9&scoped=true"
import script from "./ProfileEditFormPanelV2.vue?vue&type=script&lang=js"
export * from "./ProfileEditFormPanelV2.vue?vue&type=script&lang=js"

import "./ProfileEditFormPanelV2.vue?vue&type=style&index=0&id=5b88daf9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b88daf9"]])

export default __exports__